import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-permission',
  templateUrl: './setting-permission.component.html',
  styleUrls: ['./setting-permission.component.scss']
})
export class SettingPermissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
